<template>
  <div v-show="isShow.isPFShow" class="pg4">
    <!-- <button class="start" @click="genPoster">生成</button> -->
    <div class="img-wp">
      <img :src="mySrc" alt="" />
    </div>
    <div class="notice">长按保存你的结果页</div>
  </div>
</template>

<script>
import * as PIXI from 'pixi.js'
import { textData } from '../page-two/textData'
// import VConsole from 'vconsole'

// new VConsole()

const Application = PIXI.Application
const Sprite = PIXI.Sprite

export default {
  name: 'PageFour',
  props: {
    isShow: Object,
    sendList: Array,
    ava: String,
    name: String,
  },
  data() {
    return {
      logoImg: require('./img/fn-logo.png'),
      avaImg: require('./img/fn-avatar.png'),
      btImg: require('./img/fn-bottom-txt.jpg'),
      headerImg: require('./img/fn-header.png'),
      titleImg: require('./img/fn-title.png'),
      qrImg: require('./img/fn-qr.png'),
      mySrc: '',
      app: null,
      list: 0,
      jsonFile: '/h5/2020/changjiang100/common/logo-sprites.json',
    }
  },
  methods: {
    showNext() {
      setTimeout(() => {
        this.$emit('nextPage', 'isKVShow')
      }, 300)
    },
    genList(num) {
      const arr = []
      for (let index = 0; index < num; index++) {
        if (index < 9) {
          arr.push('0' + (index + 1))
        } else {
          arr.push('' + (index + 1))
        }
      }
      return arr
    },
    init() {
      const gotTextData = textData.map((item) => item[0])
      const gotList = this.sendList.map((item) => {
        const idxNum = gotTextData.indexOf(item)
        if (idxNum !== -1) {
          if (idxNum < 9) {
            return '0' + (idxNum + 1)
          } else {
            return '' + (idxNum + 1)
          }
        }
      })
      const list = gotList
      // const list = this.genList(100)

      const remainder = Math.ceil(list.length / 5)
      let compensate = 0
      this.list = list
      if (remainder > 5) {
        compensate = (remainder - 5) * 160
      }
      const w = 750
      const h = 1626 + compensate
      const app = new Application({
        width: w,
        height: h,
        antialias: true,
        transparent: false,
        resolution: 1,
        backgroundColor: 0xffff00,
      })
      const loader = new PIXI.Loader()
      loader.add(this.jsonFile).load(setup)

      const _this = this
      function setup(loader, resources) {
        const innerStyle = new PIXI.TextStyle({
          fontSize: 18,
          fill: ['#000000'],
        })
        _this.textureId = resources[_this.jsonFile].textures
        const baseX = 115
        const baseY = 615
        // const baseY = 20
        const offsetTop = 160
        const offsetLeft = 130
        const stage = app.stage
        const outContainer = new PIXI.Container()
        const list = _this.list
        function renderLogo(arr) {
          arr.forEach((item, idx) => {
            const topNum = Math.floor(idx / 5)
            const leftNum = idx % 5
            const curIdx = +item - 1
            item = item === '100' ? '00' : item
            const curTxt = textData[curIdx][1]
            const txtSpr = new PIXI.Text(curTxt, innerStyle)
            txtSpr.anchor.set(0.5, 0.5)

            const curSpr = Sprite.from(_this.textureId[`${item}.png`])
            curSpr.anchor.set(0.5, 0.5)
            curSpr.width = curSpr.height = 110
            curSpr.position.set(
              baseX + offsetLeft * leftNum,
              baseY + offsetTop * topNum
            )
            txtSpr.position.set(
              baseX + offsetLeft * leftNum,
              baseY + offsetTop * topNum + 80
            )
            const container = new PIXI.Container()
            container.addChild(txtSpr, curSpr)
            outContainer.addChild(container)
          })
        }
        renderLogo(list)
        stage.addChild(outContainer)
      }
      let rectangle = new PIXI.Graphics()
      rectangle.width = w
      rectangle.height = h
      rectangle.beginFill(0xffffff)
      rectangle.drawRect(0, 0, w, h)
      rectangle.endFill()
      rectangle.position.set(0, 0)

      const logoSpr = Sprite.from(this.logoImg)
      logoSpr.anchor.set(0, 0)
      logoSpr.position.set(0, 16)

      const titleSpr = Sprite.from(this.titleImg)
      titleSpr.anchor.set(0, 0)
      titleSpr.position.set(302, 122)

      const mask = new PIXI.Graphics()
      mask.beginFill(0)
      mask.drawCircle(0, 0, 60)
      mask.endFill()

      const bgSpr = new PIXI.Graphics()
      bgSpr.beginFill(0xffe400)
      bgSpr.beginFill(0xffe400)
      bgSpr.drawCircle(0, 0, 90)
      bgSpr.endFill()
      bgSpr.position.set(146, 225)
      const pre = 'https://www.jiandoukeji.com/codes/jiandou'
      const avaSpr = Sprite.from(pre + this.ava)
      // const avaSpr = Sprite.from(this.avaImg)
      avaSpr.anchor.set(0.5, 0.5)
      avaSpr.width = avaSpr.height = 180
      avaSpr.addChild(mask)
      avaSpr.mask = mask
      avaSpr.position.set(146, 225)

      const btSpr = Sprite.from(this.btImg)
      btSpr.anchor.set(0, 1)
      btSpr.position.set(0, h)

      const headerSpr = Sprite.from(this.headerImg)
      headerSpr.anchor.set(0, 0)
      headerSpr.position.set(0, 380)

      const qrSpr = Sprite.from(this.qrImg)
      qrSpr.anchor.set(0.5, 0.5)
      qrSpr.width = qrSpr.height = 136
      qrSpr.position.set(626, h - 118)

      const style = new PIXI.TextStyle({
        fontSize: 50,
        fontWeight: '700',
        fill: ['#ffffff'],
      })
      const txt = `你已完成了${this.list.length}件`
      const txtSpr = new PIXI.Text(txt, style)
      txtSpr.anchor.set(0.5, 0.5)
      txtSpr.position.set(260, 440)

      const style1 = new PIXI.TextStyle({
        fontSize: 30,
        fontWeight: '700',
        fill: ['#000000'],
      })
      const nameSpr = new PIXI.Text(this.name, style1)
      nameSpr.anchor.set(0.5, 0.5)
      nameSpr.position.set(146, 345)

      const style2 = new PIXI.TextStyle({
        fontSize: 30,
        fontStyle: 'italic',
        fontWeight: '100',
        fill: ['#000000'],
      })
      function genDate() {
        const date = new Date()
        const y = date.getFullYear()
        let m = date.getMonth() + 1
        let d = date.getDate()
        m = m < 10 ? '0' + m : m
        d = d < 10 ? '0' + d : d
        return `${y}.${m}.${d}`
      }
      const dateSpr = new PIXI.Text(genDate(), style2)
      dateSpr.anchor.set(0.5, 0.5)
      dateSpr.position.set(605, 50)

      const sprArr = [
        rectangle,
        btSpr,
        logoSpr,
        titleSpr,
        bgSpr,
        avaSpr,
        headerSpr,
        txtSpr,
        qrSpr,
        nameSpr,
        dateSpr,
      ]
      sprArr.forEach((item) => {
        app.stage.addChild(item)
      })
      this.app = app
    },
    genPoster() {
      setTimeout(() => {
        const img = this.app.renderer.plugins.extract.base64(this.app.stage)
        this.mySrc = img
      }, 500)
    },
  },
  // mounted() {
  //   this.init()
  // },
  watch: {
    sendList: function () {
      this.init()
      setTimeout(() => {
        this.genPoster()
      }, 500)
    },
  },
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  background-color: lightgoldenrodyellow;
}
img {
  width: 100%;
}
.notice {
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 8.875/2rem /* 142/16 */;
  background-color: rgba(50, 51, 51, 0.9);
  color: white;
  font-size: 1.25rem /* 20/16 */;
  line-height: 8.875/2rem /* 142/16 */;
  text-align: center;
}
</style>
